var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconstap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-296-382H854v754H-296z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 3.6,
    transform: "translate(37.3 18.6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M2.919 44.2a.6.6 0 0 0-.589.716l7.802 39.6a.6.6 0 0 0 .589.484h24.195a.6.6 0 0 0 .589-.485l7.767-39.6a.6.6 0 0 0-.588-.715H2.919z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.2 56.245h34"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M31.8 7.805c-10.098 0-15 6.623-15 16.257v10.733a.6.6 0 0 0 .6.6h13.2l-1.8 1.8v-8.231c0-3.056.08-4.29.54-5.687.729-2.205 2.38-3.482 4.86-3.482H57a.6.6 0 0 0 .6-.6V8.405a.6.6 0 0 0-.6-.6H31.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.4,
    height: 24,
    x: 49.2,
    y: 1.8,
    fill: "#FFF",
    rx: 2.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconstap);
export default __webpack_public_path__ + "static/media/iconstap.7ea29e4e5d9782a09e4832e3c218d840.svg";
export { ForwardRef as ReactComponent };